module.exports = "[hidden] {\n  display: none !important; }\n"